import { render, staticRenderFns } from "./GPTW.vue?vue&type=template&id=14a3d5eb"
import script from "./GPTW.vue?vue&type=script&lang=js"
export * from "./GPTW.vue?vue&type=script&lang=js"
import style0 from "./GPTW.vue?vue&type=style&index=0&id=14a3d5eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports